<section class="ks-acct" data-testid="business-account-step">
  <h3 class="ks-acct__title">Your bank accounts</h3>

  <ul class="ks-acct__list">
    @for (a of step().accounts; track $index) {
      <li data-testid="business-account">
        {{ a.bank_name }}
        @if (a.last_four) {
          · ending {{ a.last_four }}
        }
        @if (a.on_file) {
          <span class="ks-acct__muted">— statements on file</span>
        } @else {
          <span class="ks-acct__muted">— not uploaded: {{ a.reason }}</span>
        }
      </li>
    } @empty {
      <li class="ks-acct__muted">No accounts on file yet.</li>
    }
  </ul>

  @if (confirmation(); as c) {
    <p class="ks-acct__who" data-testid="business-account-confirmed-by">
      Confirmed by {{ c.answered_by_name
      }}{{ c.answered_as === 'AGENT' ? ' for the business' : '' }},
      {{ c.created_at | date: 'd MMM y' }}
    </p>
  }

  @if (asking()) {
    <fieldset class="ks-acct__question">
      <legend class="ks-acct__label">Are these all the bank accounts the business uses?</legend>
      <mat-radio-group
        class="ks-acct__choice"
        [value]="answer()"
        (change)="answer.set($event.value)"
      >
        <mat-radio-button value="ALL_UPLOADED">Yes — these are all of them</mat-radio-button>
        <mat-radio-button value="NOT_ALL">No — there is another account</mat-radio-button>
      </mat-radio-group>

      @if (answer() === 'NOT_ALL') {
        @for (row of rows(); track $index; let i = $index) {
          <div class="ks-acct__row" data-testid="business-account-row">
            <mat-form-field appearance="outline">
              <mat-label>Which bank</mat-label>
              <input
                matInput
                [value]="row.bank_name"
                (input)="updateRow(i, 'bank_name', $any($event.target).value)"
              />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Last four (if known)</mat-label>
              <input
                matInput
                inputmode="numeric"
                maxlength="4"
                [value]="row.last_four"
                (input)="updateRow(i, 'last_four', $any($event.target).value)"
              />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Why the statements aren't available</mat-label>
              <input
                matInput
                [value]="row.reason"
                (input)="updateRow(i, 'reason', $any($event.target).value)"
              />
            </mat-form-field>
          </div>
        }
        <button mat-button type="button" (click)="addRow()">
          <app-icon name="plus" [size]="16" />
          <span>Add another account</span>
        </button>
      }

      @if (error(); as err) {
        <p class="ks-acct__error" role="alert">{{ err }}</p>
      }
      <div class="ks-acct__actions">
        <button
          mat-stroked-button
          type="button"
          data-testid="business-account-save"
          [disabled]="!canSave() || busy()"
          (click)="save()"
        >
          {{ busy() ? 'Saving…' : 'Save' }}
        </button>
        @if (updating()) {
          <button mat-button type="button" (click)="updating.set(false)">Cancel</button>
        }
      </div>
    </fieldset>
  } @else {
    <span class="ks-acct__done" data-testid="business-account-confirmed">
      <app-icon name="check" [size]="16" />
      <span>Confirmed</span>
    </span>
    <button
      mat-button
      type="button"
      data-testid="business-account-update"
      (click)="updating.set(true)"
    >
      Update
    </button>
  }
</section>
